import moment from "moment";
import { UIDateFormat } from "../../config/dates";
import defaultReducer from "./defaultReducer";

export const graphInitialState = {
  lines: [],
  data: []
}

export const gridInitialState = {
  data: [],
  headerDef: [],
  rowDef: [],
  pageCount: 1,
  pageNumber: 1
}

export const analysisInitialState = {
    startDate: moment().subtract(14, 'days').format(UIDateFormat),
    endDate: moment().format(UIDateFormat),
    loading: false,
    graphType: 1,
    selectedRows: [],
    selectedTimeGroupBy: null,
    selectedTotalBy: null,
    selectedMeasure: null,
    selectedDayOfWeek: [],
    selectedDataGroup: null,
    selectedCategory: [],
    timeGroupBy: [],
    dataGroups: [],
    categories: [],
    daysOfWeek: [],
    measures: [],
    totalBy: [],
    grid: gridInitialState,
    graph: graphInitialState,
}

export const analysisReducer = defaultReducer('ANALYSIS_VIEW', analysisInitialState);
